module.exports = __webpack_public_path__ + "img/logo-firefox.e5023c2b.svg";